import React, { useState, useEffect } from 'react';
import AppBarMobile from './Components/AppBar';
import Home from './Pages/Home';
import WhoWeAre from './Pages/WhoWeAre'; 
import HowItWorks from './Pages/HowItWorks';
import SafetyTips from '../Shared/Pages/SafetyTips';
import CommunityGuidelines from '../Shared/Pages/CommunityGuidelines';
import PrivacyPolicy from '../Shared/Pages/PrivacyPolicy';
import TermsAndConditions from '../Shared/Pages/TermsAndConditions';
import './Mobile.module.css';

function MobileHome() {
  const [activePage, setActivePage] = useState('home');

  // Function to change page based on navigation
  const handleNavigation = (pageName) => {
    setActivePage(pageName);
    window.location.hash = pageName; // Update the hash in the URL
  };

  // Function to check URL hash and update active page
  const checkHash = () => {
    const hash = window.location.hash.replace('#', ''); // Remove the '#' from the URL hash
    if (hash) {
      setActivePage(hash); // Set the active page based on the hash value
    }
  };

  // Use useEffect to check the URL hash when the component mounts and when the hash changes
  useEffect(() => {
    checkHash(); // Check the hash when the component mounts
    window.addEventListener('hashchange', checkHash); // Listen for hash changes

    return () => {
      window.removeEventListener('hashchange', checkHash); // Cleanup event listener on unmount
    };
  }, []);

  return (
    <div className="mobile-home">
      <AppBarMobile onNavigate={handleNavigation} activePage={activePage} className="app-bar-mobile" />
      <div className="content">
        {activePage === 'home' && <Home onNavigate={handleNavigation} />}
        {activePage === 'who-we-are' && <WhoWeAre onNavigate={handleNavigation} />}
        {activePage === 'how-it-works' && <HowItWorks onNavigate={handleNavigation} />}
        {activePage === 'safety-tips' && <SafetyTips onNavigate={handleNavigation} />}
        {activePage === 'community-guidelines' && <CommunityGuidelines onNavigate={handleNavigation} />}
        {activePage === 'privacy-policy' && <PrivacyPolicy onNavigate={handleNavigation} />}
        {activePage === 'terms-and-conditions' && <TermsAndConditions onNavigate={handleNavigation} />}
      </div>
    </div>
  );
}

export default MobileHome;
